import * as React from 'react'
import ReactDOMServer from 'react-dom/server'
import { chartConfig } from './chartConfig'
import { SingleBar } from './types'
import { ToolTip } from './components'

type ChartData = {
  color: string
  bars: SingleBar[]
}

type ToolTipProps = {
  from: string
  to: string
  valueLabel: string | React.ReactElement
}

/**
 *
 * @param data
 * @param toolTipProps
 * @param hasClickThrough
 *
 * Set hasClickThrough to false if the chart can't be drilled down
 * and it will remove the hover effect, the default is set to true
 *
 * TODO: Switch out with finalized palette
 */
export function getChartConfig (
  data: ChartData[],
  toolTipProps: ToolTipProps,
  hasClickThrough = true
) {
  return {
    ...chartConfig,
    dataSource: {
      chart: {
        ...chartConfig.dataSource.chart,
        showLegend: true,
        plotHoverEffect: hasClickThrough ? 1 : 0,
        legendPosition: 'bottom',
        plotFillHoverColor: '#044E53',
        plotToolText: ReactDOMServer.renderToStaticMarkup(<ToolTip {...toolTipProps} />),
        canvasBgColor: '#F0FEFF'
      },
      categories: [
        {
          category: data[0].bars.map(({ label }) => ({ label }))
        }
      ],
      dataset: [
        {
          seriesname: 'Actions closed',
          color: '#0E7C86',
          data: data[0].bars.map(({ value }) => ({
            value,
            color: '#0E7C86',
            showValue: true,
            displayValue: value
          }))
        }
      ]
    }
  }
}
